"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slate = require("slate");

var queries = {
  isLinkActive: function isLinkActive(editor, value) {
    var inlines = value.inlines;
    return inlines.some(function (i) {
      return i.type === "link";
    });
  }
};
exports.default = queries;